export class Routing {
    static readonly main = '/';
}
